// Side-effect module: disable FontAwesome's runtime CSS injection.
// The core CSS is bundled via assets/styles.scss instead.
// This keeps it on the SSR page and lets PurgeCSS see it (no icon flash).
import {config} from "@fortawesome/fontawesome-svg-core";

config.autoAddCss = false;
